<template>
    <div>
        <pagamento-associar-despesas
            :pagamentosServicos="obterPagamentosServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
        ></pagamento-associar-despesas>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import PagamentoAssociarDespesas from '@/app/sgtec/componentes/pagamentos/PagamentoAssociarDespesas'

export default {
    props: {
        pagamento: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        }
    },

    components: {
        PagamentoAssociarDespesas
    }
}
</script>
